import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    shopifyNewUserLoading: false,
    shopifyAppstoreNewOrgCreationLoading: false,
    shopifyAppstoreConnectOrgCreationLoading: false,
    existingUserLoginLoading: false,
    fetchClientsLoading: false,

    shopifyNewUserError: null,
    shopifyConnectOrgError: null,
    existingUserLoginError: null,
    fetchClientsError: null,

    existingUserMfaRequired: false,

    existingUserAvailableOrgs: null,
    clients: null,
    shopifyNewUser: null,

    shopifyAppstoreConnectOrgModalOpen: false,
    shopifyAppstoreNewOrgModalOpen: false,
};

const appstoreSetupSlice = createSlice({
    name: "appstoreSetup",
    initialState,
    reducers: {
        getShopifyNewUserContextRequest(state) {
            state.shopifyNewUserLoading = true;
        },
        getShopifyNewUserContextSuccess(state, action) {
            state.shopifyNewUserLoading = false;
            state.shopifyNewUser = action.payload;
        },
        getShopifyNewUserContextFailure(state, action) {
            state.shopifyNewUserLoading = false;
            state.shopifyNewUserError = action.payload;
        },
        submitAppstoreNewOrgOrUserRequest(state) {
            state.shopifyAppstoreNewOrgModalOpen = true;
            state.shopifyAppstoreNewOrgCreationLoading = true;
        },
        submitAppstoreNewOrgOrUserFailure(state, action) {
            state.shopifyAppstoreNewOrgModalOpen = false;
            state.shopifyNewUserError = action.payload;
        },
        connectAppstoreToExistingOrgRequest(state) {
            state.shopifyAppstoreConnectOrgModalOpen = true;
            state.shopifyAppstoreConnectOrgCreationLoading = true;
        },
        connectAppstoreToExistingOrgFailure(state, action) {
            state.shopifyAppstoreConnectOrgCreationLoading = false;
            state.shopifyConnectOrgError = action.payload;
        },
        connectNewShopToExistingUserInitialLoginRequest(state) {
            state.existingUserLoginLoading = true;
        },
        connectNewShopToExistingUserInitialLoginSuccess(state, action) {
            state.existingUserLoginLoading = false;
            state.existingUserAvailableOrgs = action.payload.availableOrganizations;
        },
        connectNewShopToExistingUserInitialLoginFailure(state, action) {
            state.existingUserLoginLoading = false;
            state.existingUserLoginError = action.payload;
        },
        existingUserSSOMfaRequired(state) {
            // SSO popup returned auth/multi-factor-auth-required: stop the spinner and
            // switch the login step to the TOTP-code input (SSO/password form hidden).
            state.existingUserLoginLoading = false;
            state.existingUserMfaRequired = true;
        },
        existingUserSSOMfaResolved(state) {
            state.existingUserMfaRequired = false;
        },
        existingUserSSOMfaReset(state) {
            // User abandoned the TOTP step and went back to the login form.
            state.existingUserMfaRequired = false;
            state.existingUserLoginError = null;
        },
        logExistingUserIntoExistingStoreRequest(state) {
            state.existingUserLoginLoading = true;
        },
        logExistingUserIntoExistingStoreSuccess(state) {
            state.existingUserLoginLoading = false;
        },
        logExistingUserIntoExistingStoreFailure(state, action) {
            state.existingUserLoginLoading = false;
            state.existingUserLoginError = action.payload;
        },
        updateClientsRequest(state) {
            state.fetchClientsLoading = true;
        },
        updateClientsSuccess(state, action) {
            state.fetchClientsLoading = false;
            state.clients = action.payload;
        },
        updateClientsFailure(state, action) {
            state.fetchClientsLoading = false;
            state.fetchClientsError = action.payload;
        },
        closeConnectModal(state) {
            state.shopifyAppstoreConnectOrgModalOpen = false;
            state.shopifyAppstoreConnectOrgCreationLoading = false;
        },
        closeCreationModal(state) {
            state.shopifyAppstoreNewOrgModalOpen = false;
            state.shopifyAppstoreNewOrgCreationLoading = false;
        },
        setPasswordMismatchError(state) {
            state.shopifyNewUserError = "Die Passwörter müssen übereinstimmen";
        },

        setRegistrationError(state, action) {
            state.shopifyNewUserError = action.payload;
        },
        clearErrorMessages(state) {
            state.shopifyNewUserError = null;
            state.fetchClientsError = null;
            state.newOrgUserLoginError = null;
            state.existingUserLoginError = null;
        },
    },
});

export default appstoreSetupSlice;
